import { motion } from "framer-motion";
import { Activity } from "lucide-react";
import React from "react";

// Cast motion components to any to resolve TypeScript errors with framer-motion props
const MotionDiv = motion.div as any;

interface StealthInterfaceProps {
  volume: number;
}

const StealthInterface: React.FC<StealthInterfaceProps> = ({ volume }) => {
  return (
    <div className="w-full h-full bg-[#d6d3d1] text-[#1c1917] flex flex-col font-mono relative overflow-hidden select-none">
      {/* Subtle Grid */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage:
            "linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />

      {/* Header */}
      <div className="flex justify-between p-6 border-b border-black/5 z-10">
        <span className="text-xs font-semibold tracking-widest text-black/60">ZEN_OS_v1</span>
        <div className="flex gap-2 items-center">
          <div className="w-1.5 h-1.5 bg-orange-600 rounded-full animate-pulse" />
          <span className="text-xs font-semibold text-black/60">ACTIVE</span>
        </div>
      </div>

      {/* Main Display Area */}
      <div className="flex-1 flex flex-col items-center justify-center p-8 z-10">
        {/* The 'Device' Screen */}
        <div className="w-64 h-64 bg-[#e5e5e5] border border-white/50 shadow-[inset_0_2px_4px_rgba(0,0,0,0.05)] rounded-2xl flex items-center justify-center relative overflow-hidden mb-12">
          {/* Audio Waveform Simulation */}
          <div className="flex gap-1.5 items-center h-12">
            {[...Array(8)].map((_, i) => (
              <MotionDiv
                key={i}
                className="w-2.5 bg-[#44403c] rounded-full"
                animate={{ height: 8 + Math.random() * volume * 80 }}
                transition={{ type: "spring", stiffness: 300, damping: 10 }}
              />
            ))}
          </div>

          <div className="absolute top-3 left-3 text-[9px] font-bold text-black/30">MONO_OUT</div>
          <Activity className="absolute bottom-3 right-3 text-black/20 w-4 h-4" />
        </div>

        {/* Track Info */}
        <div className="w-full max-w-sm border-t border-black/5 pt-6 text-center">
          <h1 className="text-2xl font-bold tracking-tight uppercase mb-1 text-[#292524]">
            Stealth Practice
          </h1>
          <div className="text-[10px] font-medium text-black/40 tracking-widest">
            AUDIO_MASKING_ACTIVE
          </div>
        </div>
      </div>
    </div>
  );
};

export default StealthInterface;
